/**
 * Application constants
 */

// Extra margin in pixels when scrolling to element
export const SCROLL_OFFSET_PX = 20;
